import { render, staticRenderFns } from "./supplier-manager.vue?vue&type=template&id=f628d560&scoped=true&"
import script from "./supplier-manager.vue?vue&type=script&lang=js&"
export * from "./supplier-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f628d560",
  null
  
)

export default component.exports